const pleural =[

    {label:"Side",
    controlType:"radio button",
    options:["Right", "Left", "Bilateral"]
    },

    {label:"Findings",
    controlType:"checkbox group",
    options:["Poor expansion", "Dullness to percussion", "Decreased breath sounds", "Pleural rub"]
    }

]

export default pleural